var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-chart",attrs:{"id":"chart"}},[(_vm.type == 'waitingTime')?_c('h3',[_vm._v("Tempo Médio de Espera por Fila (Telefonia)")]):_c('h3',[_vm._v("Tempo Médio de Atendimento por Fila (Telefonia)")]),_vm._v(" "),_c('apexchart',{attrs:{"type":"bar","height":"450","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }